<mat-label class="custom-radio-label" *ngIf="label" [ngClass]="{ asterix: required }">
  <strong>{{ label }}</strong>
</mat-label>
<mat-radio-group
  aria-label="Select an option"
  class="custom-radio-group"
  [(ngModel)]="value"
  (ngModelChange)="ngModelChange.emit($event.value); onChange(value)"
  [disabled]="disabled"
>
  <mat-radio-button
    *ngFor="let option of options"
    [value]="_optionValue(option)"
    [disabled]="_isOptionDisabled(option)"
  >
    <span class="custom-radio-group__label">{{ _optionLabel(option) }}</span>
  </mat-radio-button>
</mat-radio-group>
